module.exports = __webpack_public_path__ + "static/walk-service-b9d332575e5458401e06d1e75189533c.svg";